(() => {
  const mount = () => {
    const root = document.querySelector('#vwd-install-page');
    if (!root || root.querySelector('.vwd-guide-finder')) return;
    const cards = [...root.querySelectorAll('.vwd-pdf-card')];
    if (!cards.length) return;
    const normalize = value => value.toLowerCase().replace(/[^a-z0-9]/g, '');
    const originals = cards.map(card => ({card, details: [...card.querySelectorAll('details')].map(el => ({el, open: el.open})), items: [...card.querySelectorAll('li')].map(el => ({el, text: normalize(el.textContent)})), text: normalize(card.textContent)}));
    const box = document.createElement('div');
    box.className = 'vwd-guide-finder';
    box.innerHTML = '<label for="vwd-guide-query">Find a PDF guide by window SKU or vehicle</label><div class="vwd-guide-finder__row"><input id="vwd-guide-query" type="search" placeholder="For example: SL101-SE or Transit" autocomplete="off" aria-describedby="vwd-guide-status"><button type="button">Reset</button></div><p id="vwd-guide-status" role="status" aria-live="polite"></p>';
    cards[0].before(box);
    const input = box.querySelector('input'), status = box.querySelector('[role="status"]');
    const filter = () => {
      const query = normalize(input.value);let matches = 0;
      for (const item of originals) {
        const match = !query || item.text.includes(query);item.card.hidden = !match;if (match) matches++;
        const specific = query && item.items.some(li => li.text.includes(query));
        for (const li of item.items) li.el.hidden = !!specific && !li.text.includes(query);
        for (const d of item.details) d.el.open = query ? match : d.open;
      }
      status.textContent = query ? (matches ? `${matches} matching guide${matches === 1 ? '' : 's'}. Confirm the applicable SKU and installation method.` : 'No matching PDF guide. Try a shorter SKU or contact tech support below.') : `${cards.length} PDF installation guides. Search to narrow the applicable SKU lists.`;
    };
    input.addEventListener('input', filter);
    box.querySelector('button').addEventListener('click', () => {input.value = '';filter();input.focus();});
    filter();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, {once: true});else mount();
  document.addEventListener('shopify:section:load', mount);
})();
